export const AuthInfo = { login: null, logout: null, loggedIn: false ,  idToken: null, accessToken: null}